import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Observable, combineLatest, map } from 'rxjs';
import { GeneralStoreService } from '../../stores/general-store.service';
import { UserAccountStoreService } from '../../stores/user-account-store.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { LoaderComponent } from '../../components/loader/loader.component';
import { TopbarComponent } from '../../components/topbar/topbar.component';
import { CookieDisclaimerService } from '../../services/cookie-disclaimer.service';
import { CookieDisclaimerComponent } from '../../shared/components/cookie-disclaimer/cookie-disclaimer.component';

interface LayoutAccountData {
  darkMode: boolean;
  isLoggedIn: boolean;
}
@Component({
  selector: 'app-layout-extra',
  standalone: true,
  imports: [
    TopbarComponent,
    RouterOutlet,
    LoaderComponent,
    NgIf,
    AsyncPipe,
    CookieDisclaimerComponent
  ],
  templateUrl: './layout-extra.component.html',
  styleUrl: './layout-extra.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class LayoutExtraComponent implements OnInit {

  layoutAccountData$!: Observable<LayoutAccountData>;
  public router = inject(Router);

  cookieDisclaimerService = inject(CookieDisclaimerService);
  private generalStore = inject(GeneralStoreService);
  private userAccountStore = inject(UserAccountStoreService);

  constructor() {
  }

  ngOnInit(): void {
    this.layoutAccountData$ = combineLatest([
      this.generalStore.darkMode$,
      this.userAccountStore.isLoggedIn$,
    ]).pipe(
      map(
        ([
          darkMode,
          isLoggedIn,
        ]) => {
          return {
            darkMode,
            isLoggedIn,
          };
        }
      )
    );
  }

}
